module.exports = __webpack_public_path__ + "img/T-coin.477b1c1.png";